const TAB_ACTIVE_BORDER = 'border-navy';
const TAB_INACTIVE_BORDER = 'border-transparent';

const initFeaturedArticlesRoot = (root) => {
  const tabs = root.querySelectorAll('.featured-articles__tab-btn');
  const panels = root.querySelectorAll('.featured-articles__panel');
  const navGroups = root.querySelectorAll('.featured-articles__nav-group');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.getAttribute('data-target');
      if (!target) return;

      tabs.forEach((item) => {
        item.classList.remove(TAB_ACTIVE_BORDER);
        item.classList.add(TAB_INACTIVE_BORDER);
        item.setAttribute('aria-selected', 'false');
      });

      tab.classList.remove(TAB_INACTIVE_BORDER);
      tab.classList.add(TAB_ACTIVE_BORDER);
      tab.setAttribute('aria-selected', 'true');

      panels.forEach((panel) => {
        if (panel.getAttribute('data-panel') === target) {
          panel.classList.remove('!hidden');
          const swiperEl = panel.querySelector('.swiper');
          if (swiperEl?.swiper) {
            requestAnimationFrame(() => swiperEl.swiper.update());
          }
        } else {
          panel.classList.add('!hidden');
        }
      });

      navGroups.forEach((group) => {
        if (group.getAttribute('data-nav') === target) {
          group.classList.remove('!hidden');
        } else {
          group.classList.add('!hidden');
        }
      });
    });
  });

  const activeTab = root.querySelector('.featured-articles__tab-btn[aria-selected="true"]');
  if (activeTab) {
    activeTab.classList.remove(TAB_INACTIVE_BORDER);
    activeTab.classList.add(TAB_ACTIVE_BORDER);
  }

  const resyncSwipers = () => {
    root.querySelectorAll('.swiper').forEach((el) => {
      el.swiper?.update();
    });
  };
  requestAnimationFrame(() => requestAnimationFrame(resyncSwipers));
  window.addEventListener('load', resyncSwipers, { once: true });
};

const initFeaturedArticles = () => {
  document
    .querySelectorAll('[data-featured-articles]:not([data-featured-articles-init])')
    .forEach((root) => {
      root.dataset.featuredArticlesInit = 'true';
      initFeaturedArticlesRoot(root);
    });
};

export default initFeaturedArticles;
